import React from 'react';
import { Link } from 'react-router-dom';

export default function PrivacyPolicy() {
  const bg = '#0a0a12';
  const card = '#0e0e1a';
  const border = '#1a1a2a';
  const text = '#b0b0c0';
  const heading = '#f0f0f2';
  const accent = '#a78bfa';

  const section = { marginBottom: 32 };
  const h2Style = { fontSize: 20, fontWeight: 700, color: heading, marginBottom: 12 };
  const pStyle = { color: text, fontSize: 15, lineHeight: 1.8, marginBottom: 12 };

  return (
    <div style={{ background: bg, minHeight: '100vh', padding: '40px 20px' }}>
      <div style={{ maxWidth: 760, margin: '0 auto' }}>
        <Link to="/" style={{ color: accent, fontSize: 14, textDecoration: 'none', display: 'inline-block', marginBottom: 24 }}>&larr; Back to Home</Link>
        <div style={{ background: card, border: '1px solid ' + border, borderRadius: 16, padding: '48px 40px' }}>
          <h1 style={{ fontSize: 32, fontWeight: 800, color: heading, marginBottom: 8 }}>Privacy Policy</h1>
          <p style={{ color: '#64748b', fontSize: 14, marginBottom: 40 }}>Last updated: March 2, 2026</p>

          <div style={section}>
            <h2 style={h2Style}>1. Who We Are</h2>
            <p style={pStyle}>IVision Marketing LLC (&ldquo;IVision,&rdquo; &ldquo;we,&rdquo; &ldquo;us,&rdquo; or &ldquo;our&rdquo;) operates the IVision CRM platform at ivisionmarketing.com. We provide booking, customer management, and marketing tools to local service businesses. Our business is located in Las Vegas, Nevada.</p>
          </div>

          <div style={section}>
            <h2 style={h2Style}>2. Information We Collect</h2>
            <p style={pStyle}>We collect information that you provide directly to us, including:</p>
            <p style={pStyle}><strong style={{ color: heading }}>Business Owners:</strong> Name, email address, phone number, business name, business address, and payment information when you subscribe to our platform.</p>
            <p style={pStyle}><strong style={{ color: heading }}>End Customers:</strong> Name, phone number, email address, and appointment details when you book services through a business using our platform.</p>
            <p style={pStyle}><strong style={{ color: heading }}>Automatically Collected:</strong> We may collect device information, IP address, browser type, and usage data through cookies and similar technologies to improve our services.</p>
          </div>

          <div style={section}>
            <h2 style={h2Style}>3. How We Use Your Information</h2>
            <p style={pStyle}>We use the information we collect to: provide and maintain our platform; send appointment reminders and booking confirmations via SMS and email; process transactions and send billing information; send promotional messages when you have opted in; improve and personalize our services; and comply with legal obligations.</p>
          </div>

          <div style={section}>
            <h2 style={h2Style}>4. SMS Messaging</h2>
            <p style={pStyle}>Our platform sends SMS messages on behalf of businesses using our service. These messages may include appointment reminders, booking confirmations, review requests, and promotional offers. By providing your phone number during the booking process, you consent to receiving these messages. You may opt out at any time by replying STOP to any message. Message and data rates may apply. Message frequency varies based on your appointment activity.</p>
          </div>

          <div style={section}>
            <h2 style={h2Style}>5. Data Sharing</h2>
            <p style={pStyle}>We do not sell your personal information. We share data only with: service providers who assist in operating our platform (such as Twilio for messaging, Stripe for payments, and Supabase for data storage); the specific business you booked an appointment with; and when required by law or to protect our legal rights.</p>
          </div>

          <div style={section}>
            <h2 style={h2Style}>6. Data Security</h2>
            <p style={pStyle}>We implement industry-standard security measures to protect your information, including encrypted data transmission (SSL/TLS), secure database storage with row-level security, and access controls. However, no method of transmission over the internet is 100% secure.</p>
          </div>

          <div style={section}>
            <h2 style={h2Style}>7. Data Retention</h2>
            <p style={pStyle}>We retain your information for as long as your account is active or as needed to provide services. Business owners may request deletion of their data by contacting us. End customer data is managed by the business that collected it.</p>
          </div>

          <div style={section}>
            <h2 style={h2Style}>8. Your Rights</h2>
            <p style={pStyle}>You have the right to: access the personal information we hold about you; request correction of inaccurate information; request deletion of your information; opt out of promotional communications at any time; and request a copy of your data.</p>
          </div>

          <div style={section}>
            <h2 style={h2Style}>9. Changes to This Policy</h2>
            <p style={pStyle}>We may update this privacy policy from time to time. We will notify you of any material changes by posting the new policy on this page and updating the &ldquo;last updated&rdquo; date.</p>
          </div>

          <div style={section}>
            <h2 style={h2Style}>10. Contact Us</h2>
            <p style={pStyle}>If you have questions about this privacy policy or your data, contact us at:</p>
            <p style={pStyle}>IVision Marketing LLC<br />Las Vegas, Nevada<br />Email: support@ivisionmarketing.com<br />Website: ivisionmarketing.com</p>
          </div>
        </div>
      </div>
    </div>
  );
}
